export const getCountryFlag = (countryCode: string): string => {
  const flags: { [key: string]: string } = {
    'EN': '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
    'SC': '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
    'WA': '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
    'IE': '🇮🇪',
    'ES': '🇪🇸',
    'DE': '🇩🇪',
    'IT': '🇮🇹',
    'FR': '🇫🇷',
    'NL': '🇳🇱',
    'PT': '🇵🇹',
    'BE': '🇧🇪',
    'US': '🇺🇸',
    'CA': '🇨🇦',
    'MX': '🇲🇽',
    'AU': '🇦🇺',
    'BR': '🇧🇷',
  };
  return flags[countryCode] || '⚽';
};

export const countryOptions = [
  { code: 'EN', name: 'England', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿' },
  { code: 'SC', name: 'Scotland', flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿' },
  { code: 'WA', name: 'Wales', flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿' },
  { code: 'IE', name: 'Ireland', flag: '🇮🇪' },
  { code: 'ES', name: 'Spain', flag: '🇪🇸' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪' },
  { code: 'IT', name: 'Italy', flag: '🇮🇹' },
  { code: 'FR', name: 'France', flag: '🇫🇷' },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱' },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹' },
  { code: 'BE', name: 'Belgium', flag: '🇧🇪' },
  { code: 'US', name: 'United States', flag: '🇺🇸' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { code: 'MX', name: 'Mexico', flag: '🇲🇽' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺' },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷' },
]; 